<template>
  <div class="tab-content">
    <div class="tab-pane fade show active" v-if="currentTab == 'reset'">
      <customer-reset :customer="customer"></customer-reset>
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'purchases'">
      <customer-purchases :customer="customer"></customer-purchases>
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'discounts'">
      <customer-show-discount-info-card :customer="customer" :discounts="discounts" @deleteDiscount="deleteDiscount" />
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'customer' && customer">
      <customer-show-customer-info-card
        :customer="customer"
        :third-party-managed="thirdPartyManaged"
        @onboard="onboard"
      />
      <br />
      <customer-show-customer-info-admin-card :customer="customer" />
      <br />
      <customer-show-customer-info-billing-card :customer="customer" />
      <br />
      <customer-show-customer-info-organization-card
        :customer="customer"
        :whitelabel-organizations="whitelabelOrganizations"
        :whitelabel-plans="whitelabelPlans"
        v-if="!thirdPartyManaged"
      />
      <br />
      <customer-show-customer-info-archive-card
        v-if="!thirdPartyManaged && can('write_developer_actions')"
        :customer="customer"
        :third-party-managed="thirdPartyManaged"
        @archiveCustomer="archiveCustomer"
      />
    </div>
    <div class="tab-pane fade active show" v-if="currentTab == 'invoices'">
      <div class="card" v-if="customer">
        <div class="card-body">
          <h4 class="mb-2">{{ 'invoices' | t }}</h4>
          <br />
          <invoices-table :invoices="invoices" />
        </div>
      </div>
    </div>
    <div class="tab-pane fade active show" v-if="currentTab == 'events'">
      <customer-events :customer="customer" />
    </div>
    <div class="tab-pane fade active show" v-if="currentTab == 'changes'">
      <customer-change-logs :customer="customer" />
    </div>
    <customer-show-customer-tab-payments
      v-if="currentTab == 'payments'"
      :customer="customer"
      :payments="payments"
      @deletePayment="deletePayment"
    />
    <div class="tab-pane fade active show" v-if="currentTab == 'subscription'">
      <div v-if="customer?.subscription">
        <subscription-form
          :subscription="customer.subscription"
          :customer="customer"
          :currency="customer.currency"
          :customer_id="customer.id"
        />
      </div>
    </div>
    <div class="tab-pane fade active show" v-if="currentTab == 'quote'">
      <div v-if="customer">
        <customer-creation-quote v-model="customer.quote" :customer="customer" />
      </div>
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'users'">
      <RevokeCustomerTokensCard :customer="customer" />
      <user-index v-model="users" v-on:done="getUsers" ref="userlist" />
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'staff_accesses'">
      <customer-staff-accesses
        v-model="staffAccesses"
        v-on:done="getStaffAccesses"
        :customer="customer"
        ref="staffAccessList"
      />
    </div>
    <div class="tab-pane fade show active" v-if="currentTab == 'replaced_subscriptions'">
      <customer-replaced-subscriptions :replaced_subscriptions="customer.replaced_subscriptions" :customer="customer" />
    </div>
  </div>
</template>

<script>
import RevokeCustomerTokensCard from './cards/customer/revoke-customer-tokens-card';
export default {
  props: {
    customer: Object,
    currentTab: String,
    payments: Array,
    invoices: Array,
    discounts: Array,
    thirdPartyManaged: Boolean,
    whitelabelOrganizations: Array,
    whitelabelPlans: Array,
    users: Array,
    staffAccesses: Array
  },
  components: {
    RevokeCustomerTokensCard
  },
  methods: {
    deletePayment(payment) {
      this.$emit('deletePayment', payment);
    },
    deleteDiscount(discount) {
      this.$emit('deleteDiscount', discount);
    },
    archiveCustomer() {
      this.$emit('archiveCustomer');
    },
    confirmModal(event, title, message, callback) {
      this.$emit('confirmModal', event, title, message, callback);
    },
    getUsers() {
      this.$emit('getUsers');
    },
    getStaffAccesses() {
      this.$emit('getStaffAccesses');
    },
    onboard() {
      this.$emit('onboard');
    }
  }
};
</script>
